/** Shared layout class strings for the bookings list. */

export const EDGE_PADDING_CLASSES = 'px-4 md:px-8';

// Each row is a spaced, bordered card at every breakpoint (border, no shadow).
export const ROW_LIST_CLASSES = 'flex flex-col gap-3';

// Rows are a stacked card on mobile and a fixed 5-column grid card from md up
// so every section lines up: thumbnail · title/meta · badge · price · actions.
// The two wrapper groups use `md:contents` so their children become direct
// grid items at md+.
export const ROW_GRID_CLASSES =
  'flex flex-col gap-3 rounded-md border bg-card p-4 md:grid md:grid-cols-[5rem_minmax(0,1fr)_6rem_7rem_14rem] md:items-center md:gap-4';
